import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ClassStoreState = {
  section_list: [],
};

const setSections: CaseReducer<ClassStoreState, PayloadAction<Section[]>> = (state, action) => {
  state.section_list = action.payload;
};

const classesSlice = createSlice({
  name: 'sectionSlice',
  initialState,
  reducers: { setSections },
});

export const classActions = classesSlice.actions;

export default classesSlice.reducer;
